<template>
  <div id="app">
    <div id="editor" ref="editor"></div>
    <div id="iframe-wrapper" :style="iframe.wrapperStyle">
      <iframe
        v-if="loaded"
        :style="iframe.style"
        :height="iframe.style.height"
        :width="iframe.style.width"
        :src="linkIframe"
        type="application/pdf"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      linkIframe: process.env.VUE_APP_LINK_REPORT_REFUND,
      loaded: false,
      iframe: {
        style: null,
        wrapperStyle: null
      }
    };
  },
  mounted() {
    let editor = this.$refs.editor;
    this.iframe.style = {
      position: "absolute",
      width: window.innerWidth,
      height: window.innerHeight,
      top: -editor.offsetTop + "px",
      left: -editor.offsetLeft + "px"
    };
    this.iframe.wrapperStyle = {
      overflow: "hidden",
      height: editor.clientHeight + "px",
      width: editor.clientWidth + "px"
    };
    this.loaded = true;
  }
};
</script>
